export const isMobile = () => window.screen.width < 1024;
